const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-map-pin-line',
      title: 'Localização Premium',
      description: 'A 5 minutos da praia e do centro do Funchal, com fácil acesso a todas as atrações',
    },
    {
      icon: 'ri-key-line',
      title: 'Check-in Autónomo 24h',
      description: 'Flexibilidade total com sistema de entrada automática, chegue quando quiser',
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Vistas Deslumbrantes',
      description: 'Apartamentos com vista mar, montanha ou jardim para uma experiência única',
    },
    {
      icon: 'ri-parking-box-line',
      title: 'Estacionamento Incluído',
      description: 'Lugar de estacionamento gratuito para cada apartamento, sem custos extra',
    },
    {
      icon: 'ri-wifi-line',
      title: 'WiFi Fibra 500Mbps',
      description: 'Internet de alta velocidade para trabalhar ou relaxar com streaming',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Cozinha Equipada',
      description: 'Cozinha completa com todos os utensílios e eletrodomésticos modernos',
    },
  ];

  return (
    <section className="py-20 bg-sand-beige">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-nature-green text-sm font-semibold uppercase tracking-wider mb-3">
            Porquê Escolher-nos
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-navy-blue mb-4">
            Tudo o Que <span className="font-serif italic">Precisa</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Oferecemos todas as comodidades para tornar a sua estadia inesquecível
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-sea-blue mb-6">
                <i className={`${benefit.icon} text-3xl text-sea-blue`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy-blue mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;